import {useSelector} from 'react-redux';

import {selectIsMobileLayout} from '../../state/selectors/global';
import Popup from './Popup';
import PopupSticked from './PopupSticked';

const PopupMobileSticked = (props) => {
    const isMobileLayout = useSelector(selectIsMobileLayout);
    const Component = isMobileLayout ? PopupSticked : Popup;

    return <Component {...props} />;
};

export default PopupMobileSticked;
